import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import Timer from "../../Timer";
import "../../../styles/org-buttons.css";
import "../../../styles/Dataset.css";
import "./ImportStorageModal.css";
import { buttonText } from "../../../utils/buttonText";

function ImportStorageModal(props) {
  const { show, onHide, item, loadProjectList, folders } = props;

  const [title, setTitle] = useState(null);
  const [folder, setFolder] = useState(null);
  const [regex, setRegex] = useState(null);
  const [importAnnotated, setImportAnnotated] = useState(false);
  const [folderLoading, setFolderLoading] = useState(false);

  const importFolder = async () => {
    if (!folder) {
      window.alert(`No folder name.`);
      return;
    }
    setFolderLoading(true);
    try {
      if (importAnnotated) {
        let url = `/label_studio/project/import/annotated_task?project_id=${item.id}&folder_name=${folder}`;
        if (title) {
          url += `&title=${title}`;
        }
        if (regex) {
          url += `&regex_filter=${regex}`;
        }
        await axios.put(url);
        window.alert(`Import folder '${folder}' success, you can go to label studio webiste to config`);
      } else {
        let url = `/label_studio/project/import/folder?project_id=${item.id}&folder_name=${folder}`;
        if (title) {
          url += `&title=${title}`;
        }
        if (regex) {
          url += `&regex_filter=${regex}`;
        }
        await axios.put(url);
        window.alert(`Import folder '${folder}' success, you can go to label studio webiste to config`);
      }
      loadProjectList();
      onHide();
    } catch (error) {
      let errorMsg = error.response?.data || error.message;
      window.alert(errorMsg);
    }
    setFolderLoading(false);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      className="dataset-enterprise-modal import-storage-modal"
      dialogClassName="import-storage-modal-dialog"
    >
      <Modal.Header closeButton closeLabel={buttonText("Close")} className="dataset-modal-header">
        <Modal.Title>Import Storage</Modal.Title>
      </Modal.Header>
      <Modal.Body className="dataset-modal-body">
        <div className="dataset-modal-form">
          <div className="dataset-modal-field">
            <label htmlFor="folder-select">Folder</label>
            <select
              id="folder-select"
              value={folder || ""}
              onChange={(e) => setFolder(e.target.value)}
            >
              <option value="">Please choose an option</option>
              {folders &&
                folders.map((f) => (
                  <option key={`${item.id}-${f.name}-${f.type}`} value={f.name}>
                    {f.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="dataset-modal-field">
            <label htmlFor="storage-title">Storage Title</label>
            <input
              id="storage-title"
              type="text"
              value={title || ""}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div className="dataset-modal-field">
            <label htmlFor="file-filter-regex">File Filter Regex</label>
            <input
              id="file-filter-regex"
              type="text"
              value={regex || ""}
              placeholder=".*csv or .*(jpe?g|png|tiff) or .\w+-\d+.test"
              onChange={(e) => setRegex(e.target.value)}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="org-modal-footer import-modal-footer">
        <div className="import-modal-actions">
          <button
            type="button"
            className="org-btn org-btn-primary"
            onClick={importFolder}
            disabled={folderLoading}
          >
            {buttonText(folderLoading ? <Timer loadingStates={[folderLoading]} /> : "Import Storage")}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default ImportStorageModal;
